import { Column, COLUMN_NAMES, COLUMN_RESOURCES } from "../../shared";

export const VEHICLES_TABLE_COLUMNS: Column[] = [
  {
    name: COLUMN_NAMES.Schedules,
    isSticky: false,
    resource: COLUMN_RESOURCES.SchedulesList,
    isDefaultActive: true,
    isDisabled: true
  },
  {
    name: COLUMN_NAMES.VehicleNumber,
    isSticky: false,
    resource: COLUMN_RESOURCES.Number,
    sortResource: COLUMN_RESOURCES.Number,
    isDefaultActive: true,
    isDisabled: true
  },
  {
    name: COLUMN_NAMES.DeviceImei,
    isSticky: true,
    resource: COLUMN_RESOURCES.Imei,
    isDefaultActive: true,
    isDisabled: true,
    width: "150px"
  },
  {
    name: COLUMN_NAMES.DeviceStatus,
    isSticky: false,
    resource: COLUMN_RESOURCES.Status,
    isDefaultActive: true,
    isBadge: true
  },
  {
    name: COLUMN_NAMES.Description,
    resource: COLUMN_RESOURCES.Comment,
    isDefaultActive: true
  },
  {
    name: COLUMN_NAMES.LastConnection,
    isSticky: false,
    resource: COLUMN_RESOURCES.LastConnected,
    sortResource: COLUMN_RESOURCES.LastConnected,
    isDefaultActive: true
  },
  {
    name: COLUMN_NAMES.LastDownload,
    isSticky: false,
    resource: COLUMN_RESOURCES.LastSuccessfulDownloadTime,
    sortResource: COLUMN_RESOURCES.LastSuccessfulDownloadTime,
    isDefaultActive: true
  },
  {
    name: COLUMN_NAMES.CreditStatus,
    isSticky: false,
    resource: COLUMN_RESOURCES.CreditStatus,
    sortResource: COLUMN_RESOURCES.CreditStatus,
    isDefaultActive: true
  },
  {
    name: COLUMN_NAMES.CreatedBy,
    resource: COLUMN_RESOURCES.CreatedBy,
    sortResource: COLUMN_RESOURCES.CreatedBy,
    isDefaultActive: true
  },
  {
    name: COLUMN_NAMES.CreatedAt,
    resource: COLUMN_RESOURCES.CreatedAt,
    sortResource: COLUMN_RESOURCES.CreatedAt,
    isDefaultActive: true
  },
  {
    name: COLUMN_NAMES.UpdatedAt,
    resource: COLUMN_RESOURCES.UpdatedAt,
    sortResource: COLUMN_RESOURCES.UpdatedAt,
    isDefaultActive: true
  }
];
